export default "__VITE_ASSET__DFH6GJmW__"